var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`app-user app-user--${_vm.view}`},[(_vm.view !== 'text')?[_c('img',{staticClass:"app-user__pic",attrs:{"src":_vm.baseUser.userpicUrl,"alt":"user"}})]:_vm._e(),(_vm.view !== 'pic')?[_c('span',{staticClass:"app-user__name d-none d-md-inline-block"},[_vm._v(_vm._s(_vm.baseUser.username))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }